import { useMemo, useState } from 'react'

import { useLocale } from '@ecomm/data-hooks'
import { useCameraOnlyLPCTAExperience } from '@ecomm/shared-ninetailed'
import { useBusiness } from '@ecomm/smb-components/BusinessProvider/BusinessProvider'
import { NavLink } from './NavLink'
import { NavMenu } from './NavMenu'
import { getMainMenuItems } from './data'
import type { HeaderRedesignSchema } from './schema'

export function MainNav(props: HeaderRedesignSchema) {
  const { isCameraOnlyVariant } = useCameraOnlyLPCTAExperience()
  const locale = useLocale()

  const [activeDropdownIndex, setActiveDropdownIndex] = useState(-1)

  const { isBusiness } = useBusiness()

  const menuItems = useMemo(() => {
    return getMainMenuItems(locale, isCameraOnlyVariant, isBusiness)
  }, [locale, isCameraOnlyVariant, isBusiness])

  return (
    <div className="hidden h-full items-center justify-between gap-6 justify-self-start text-lg min-[1126px]:flex min-[1185px]:gap-10">
      {menuItems.map((item, i) =>
        item.hasDropdown ? (
          <NavMenu
            dropdownMenu={item.dropdownMenu}
            key={item.text}
            mainNavDesktop={true}
            onToggleDropdown={(close?: boolean) => {
              setActiveDropdownIndex(
                close ? -1 : activeDropdownIndex === i ? -1 : i
              )
            }}
            showDropdown={activeDropdownIndex === i}
            text={item.text}
            {...props}
          />
        ) : (
          <NavLink
            key={item.text}
            openQuiz={item.openQuiz}
            quoteWizard={{ ...props.quoteWizard }}
            text={item.text}
            url={item.url}
          />
        )
      )}
    </div>
  )
}
